import React from 'react'
import { useIntl } from 'react-intl'
import { FormSubGroup, Label } from '../../layout'
import { SelectContainer, useTowingJobFilterContext } from '../context'
import { FilterSelect } from '../components/FilterSelect'
import { MultiValue, Option } from '../components/MultiValueSelect'
import { towingJobFilterMessages } from '../messages'
import { formatMessageSafe } from '../../../util/translateInputOptions'

interface StationOption {
  label: string
  value: number
}

interface StationOptionsProps {
  options: StationOption[]
}

export const StationFilter = ({ options }: StationOptionsProps) => {
  const { values, setValues } = useTowingJobFilterContext()
  const { stations } = values.filters
  const intl = useIntl()
  const formatMessage = formatMessageSafe(intl)

  const optionsValues = options

  const handleLabelChange = (selectedOptions: any) => {
    const selectedStations = selectedOptions ? selectedOptions.map((opt: any) => opt.value) : []

    setValues({
      ...values,
      filters: {
        ...values.filters,
        stations: selectedStations,
      },
    })
  }

  return (
    <FormSubGroup>
      <Label htmlFor="filter-multiselect">{formatMessage(towingJobFilterMessages.stationLabel)}</Label>
      <SelectContainer>
        <FilterSelect
          isMulti
          closeMenuOnSelect={false}
          isSearchable={false}
          hideSelectedOptions={false}
          placeholder={formatMessage(towingJobFilterMessages.selectPlaceholder)}
          options={optionsValues.map(option => ({ value: option.value, label: option.label }))}
          value={optionsValues
            .filter(option => stations.includes(option.value))
            .map(option => ({ value: option.value, label: option.label }))}
          onChange={handleLabelChange}
          components={{ MultiValue, Option }}
          maxToShow={3}
        />
      </SelectContainer>
    </FormSubGroup>
  )
}
